<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">
        MOH 643 - DAILY ACTIVITY REGISTER (PHARMACY)
      </div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Prescriptions</span>
        <span class="stat-number">{{ totalPrescriptions }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Items Dispensed</span>
        <span class="stat-number">{{ totalItems }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Total Value (KSh)</span>
        <span class="stat-number">{{ totalValue }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Stock Outs</span>
        <span class="stat-number">{{ totalStockOuts }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="pharmacy-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Prescription No</th>
            <th>Patient Names</th>
            <th>Age</th>
            <th>Sex</th>
            <th>Contact</th>
            <th>Drug Name</th>
            <th>Strength</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Dosage Instructions</th>
            <th>Duration (days)</th>
            <th>Unit Price (KSh)</th>
            <th>Total Price (KSh)</th>
            <th>Payment Mode</th>
            <th>Prescriber</th>
            <th>Dispenser</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.prescriptionNo }}</td>
            <td>{{ record.patientNames }}</td>
            <td>{{ record.age }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.drugName }}</td>
            <td>{{ record.strength }}</td>
            <td class="text-center">{{ record.quantity }}</td>
            <td>{{ record.unit }}</td>
            <td>{{ record.dosage }}</td>
            <td class="text-center">{{ record.duration }}</td>
            <td class="text-right">{{ record.unitPrice }}</td>
            <td class="text-right">
              <strong>{{ record.totalPrice }}</strong>
            </td>
            <td class="text-center">{{ record.paymentMode }}</td>
            <td>{{ record.prescriber }}</td>
            <td>{{ record.dispenser }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="19" class="empty-row">
              No pharmacy records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH643Pharmacy",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      pharmacyRecords: [
        {
          date: "2026-04-22",
          prescriptionNo: "RX001",
          patientNames: "John Mwenda",
          age: "32",
          sex: "M",
          contact: "0712345678",
          drugName: "Paracetamol",
          strength: "500mg",
          quantity: 30,
          unit: "Tablets",
          dosage: "1 tab every 8 hours",
          duration: 10,
          unitPrice: 5,
          totalPrice: 150,
          paymentMode: "Cash",
          prescriber: "Dr. S. Mwangi",
          dispenser: "J. Karani",
          remarks: "For fever",
        },
        {
          date: "2026-04-22",
          prescriptionNo: "RX002",
          patientNames: "Mary Wanjiku",
          age: "28",
          sex: "F",
          contact: "0723456789",
          drugName: "Amoxicillin",
          strength: "500mg",
          quantity: 21,
          unit: "Capsules",
          dosage: "1 cap every 12 hours",
          duration: 7,
          unitPrice: 8,
          totalPrice: 168,
          paymentMode: "NHIF",
          prescriber: "Dr. S. Mwangi",
          dispenser: "P. Muthoni",
          remarks: "For UTI",
        },
        {
          date: "2026-04-22",
          prescriptionNo: "RX003",
          patientNames: "Mary Wanjiku",
          age: "28",
          sex: "F",
          contact: "0723456789",
          drugName: "Ciprofloxacin",
          strength: "250mg",
          quantity: 14,
          unit: "Tablets",
          dosage: "1 tab every 12 hours",
          duration: 7,
          unitPrice: 10,
          totalPrice: 140,
          paymentMode: "NHIF",
          prescriber: "Dr. S. Mwangi",
          dispenser: "P. Muthoni",
          remarks: "For UTI",
        },
        {
          date: "2026-04-21",
          prescriptionNo: "RX004",
          patientNames: "Peter Kimathi",
          age: "45",
          sex: "M",
          contact: "0734567890",
          drugName: "Artemether/Lumefantrine",
          strength: "20/120mg",
          quantity: 24,
          unit: "Tablets",
          dosage: "4 tabs twice daily x 3 days",
          duration: 3,
          unitPrice: 25,
          totalPrice: 600,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "J. Karani",
          remarks: "For malaria",
        },
        {
          date: "2026-04-21",
          prescriptionNo: "RX005",
          patientNames: "Grace Muthoni",
          age: "35",
          sex: "F",
          contact: "0745678901",
          drugName: "Lisinopril",
          strength: "10mg",
          quantity: 60,
          unit: "Tablets",
          dosage: "1 tab daily",
          duration: 60,
          unitPrice: 6,
          totalPrice: 360,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "P. Muthoni",
          remarks: "For hypertension",
        },
        {
          date: "2026-04-20",
          prescriptionNo: "RX006",
          patientNames: "James Mwirigi",
          age: "52",
          sex: "M",
          contact: "0756789012",
          drugName: "Metformin",
          strength: "500mg",
          quantity: 90,
          unit: "Tablets",
          dosage: "1 tab twice daily",
          duration: 45,
          unitPrice: 4,
          totalPrice: 360,
          paymentMode: "NHIF",
          prescriber: "Dr. S. Mwangi",
          dispenser: "J. Karani",
          remarks: "For diabetes",
        },
        {
          date: "2026-04-20",
          prescriptionNo: "RX007",
          patientNames: "Lucy Mwende",
          age: "29",
          sex: "F",
          contact: "0767890123",
          drugName: "Ferrous Sulfate",
          strength: "200mg",
          quantity: 60,
          unit: "Tablets",
          dosage: "1 tab daily",
          duration: 60,
          unitPrice: 3,
          totalPrice: 180,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "P. Muthoni",
          remarks: "For anaemia",
        },
        {
          date: "2026-04-20",
          prescriptionNo: "RX008",
          patientNames: "Lucy Mwende",
          age: "29",
          sex: "F",
          contact: "0767890123",
          drugName: "Folic Acid",
          strength: "5mg",
          quantity: 30,
          unit: "Tablets",
          dosage: "1 tab daily",
          duration: 30,
          unitPrice: 2,
          totalPrice: 60,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "P. Muthoni",
          remarks: "Supplement",
        },
        {
          date: "2026-04-19",
          prescriptionNo: "RX009",
          patientNames: "Esther Kendi",
          age: "41",
          sex: "F",
          contact: "0778901234",
          drugName: "ORS Sachets",
          strength: "",
          quantity: 10,
          unit: "Sachets",
          dosage: "As needed",
          duration: 5,
          unitPrice: 15,
          totalPrice: 150,
          paymentMode: "Cash",
          prescriber: "Dr. S. Mwangi",
          dispenser: "J. Karani",
          remarks: "For dehydration",
        },
        {
          date: "2026-04-19",
          prescriptionNo: "RX010",
          patientNames: "Samuel Mutuma",
          age: "8",
          sex: "M",
          contact: "0789012345",
          drugName: "Paracetamol Syrup",
          strength: "120mg/5ml",
          quantity: 1,
          unit: "Bottle",
          dosage: "5ml every 8 hours",
          duration: 5,
          unitPrice: 120,
          totalPrice: 120,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "P. Muthoni",
          remarks: "For fever",
        },
        {
          date: "2026-04-18",
          prescriptionNo: "RX011",
          patientNames: "Naomi Gacheri",
          age: "33",
          sex: "F",
          contact: "0790123456",
          drugName: "AZT/3TC/NVP (ARVs)",
          strength: "",
          quantity: 60,
          unit: "Tablets",
          dosage: "1 tab twice daily",
          duration: 30,
          unitPrice: 0,
          totalPrice: 0,
          paymentMode: "Free",
          prescriber: "Dr. S. Mwangi",
          dispenser: "J. Karani",
          remarks: "ART refill",
        },
        {
          date: "2026-04-18",
          prescriptionNo: "RX012",
          patientNames: "Mercy Kajuju",
          age: "22",
          sex: "F",
          contact: "0701234567",
          drugName: "Combined Oral Contraceptives",
          strength: "",
          quantity: 1,
          unit: "Pack",
          dosage: "1 tab daily",
          duration: 28,
          unitPrice: 50,
          totalPrice: 50,
          paymentMode: "Cash",
          prescriber: "Dr. A. Muchene",
          dispenser: "P. Muthoni",
          remarks: "Family planning",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.pharmacyRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }
      return filtered;
    },
    totalPrescriptions() {
      // Count unique prescription numbers
      const unique = new Set();
      this.filteredRecords.forEach((r) => unique.add(r.prescriptionNo));
      return unique.size;
    },
    totalItems() {
      return this.filteredRecords.length;
    },
    totalValue() {
      const sum = this.filteredRecords.reduce(
        (acc, r) => acc + (r.totalPrice || 0),
        0,
      );
      return sum.toLocaleString();
    },
    totalStockOuts() {
      return this.filteredRecords.filter(
        (r) => r.remarks && r.remarks.toLowerCase().includes("out of stock"),
      ).length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.pharmacy-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1500px;
}

.pharmacy-table th {
  background: #1f2937;
  color: white;
  padding: 10px 6px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.pharmacy-table td {
  border: 1px solid #d1d5db;
  padding: 8px 6px;
  text-align: left;
}

.pharmacy-table td.text-center {
  text-align: center;
}

.pharmacy-table td.text-right {
  text-align: right;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .pharmacy-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .pharmacy-table th {
    padding: 4px 3px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pharmacy-table td {
    padding: 4px 3px;
    font-size: 7.5px;
  }
}
</style>
